import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import style from "./style.module.scss";

/**
 * TotalAttempts:
 *  - Component display TotalAttempts left for Question
 */
export function TotalAttempts(props) {
  const { isPredictionQuestion = false } = props;
  const { hideAttemptsLeft = true } = props;
  const intl = useIntl();

  const renderTotalCount = () => {
    if (props.totalAttempts == "-1") {
      return intl.formatMessage({
        id: "Unlimited",
        defaultMessage: "Unlimited",
        description: "",
      });
    } else {
      return props.totalAttempts;
    }
  };

  const className = `${style.attempts} ${props.className}`;

  return (
    <span className={className}>
      {!isPredictionQuestion && !hideAttemptsLeft && (
        <FormattedMessage
          id={"Attempts left: {count}"}
          defaultMessage={"Attempts left: {count}"}
          values={{ count: renderTotalCount() }}
          description=""
        />
      )}
    </span>
  );
}

TotalAttempts.propTypes = {
  /**
   * To display total attempts
   */
  totalAttempts: PropTypes.number.isRequired,
  /**
   * ClassName for the question wrapper
   */
  className: PropTypes.string,
};

TotalAttempts.defaultProps = {
  className: "",
  totalAttempts: 0,
};
